"use strict";
module.exports = {
    strings: {
        generatingThumbnails: 'Generating thumbnails...'
    }
};
